import { g as r } from "../internals/global.js";
import { d as o } from "../internals/dom-iterables.js";
import { d as a } from "../internals/dom-token-list-prototype.js";
import { a as t } from "../internals/array-for-each.js";
import { c as e } from "../internals/create-non-enumerable-property.js";
var n = function n(r) {
  if (r && r.forEach !== t) try {
    e(r, "forEach", t);
  } catch (o) {
    r.forEach = t;
  }
};
for (var s in o) o[s] && n(r[s] && r[s].prototype);
n(a);